export default class Contato {
    constructor(){
        this.motivo = '',
        this.email = '',
        this.telefone = '',
        this.assunto = '',
        this.mensagem = ''
    }
}